export default __webpack_public_path__ + "static/icon-windmill-7fdc3b2684b81780605624bab167ec9a.svg";